import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Common Layout Components
import Navbar from './Components/navbar/Navbar';
import Footer from './Components/Footer/Footer';

// Page Components
import Header from './Components/header/Header';
import AboutUs from './Components/About/About';
import FemaleModel from './Components/Models/FemaleModel';
import Testimonial from './Components/Testimonial/Testimonial';
import MaleModel from './Components/Models/MaleModel';
import FemalechildModel from './Components/Models/FemalechildModel';
import MalechildModel from './Components/Models/MalechildModel';
import ContactUs from './Components/Contact/Contact';
import Fashionphotoshoot from './Components/Photoshoot/FashionPhotoshoot/Fashionphotoshoot';
import Modelphotoshoot from './Components/Photoshoot/Modelphoroshoot/Modelphotoshoot';

// Home Page combining landing sections
const HomePage = () => (
  <>
    <Header />
    {/* <FemaleModel /> */}
    {/* <Testimonial /> */}
    <AboutUs/>
  </>
);

function App() {
  return (
    <Router>
      <Navbar />

      <Routes>
        {/* Home Route */}
        <Route path="/" element={<HomePage />} />

        {/* Individual Page Routes */}
        {/* <Route path="/about" element={<AboutUs />} /> */}
        <Route path="/female-models" element={<FemaleModel />} />
        <Route path="/male-models" element={<MaleModel />} />
        <Route path="/childfemale-models" element={<FemalechildModel />} />
        <Route path="/childmale-models" element={<MalechildModel />} />

        <Route path="/fashion-photos" element = {<Fashionphotoshoot/>} />
        <Route path='/model-photos' element = {<Modelphotoshoot/>}/>

        {/* <Route path="/testimonials" element={<Testimonial />} /> */}
        <Route path='/contactus' element = { <ContactUs/>}/>

        {/* 404 Fallback */}
        <Route
          path="*"
          element={
            <div style={{ textAlign: 'center', padding: '80px 20px', minHeight: '50vh' }}>
              <h2>404 - Page Not Found</h2>
            </div>
          }
        />
      </Routes>

      <Footer />
    </Router>
  );
}

export default App;